import styled from 'styled-components';
import { ReadOnlyTag } from '../../atoms/Tag';
import { UserIcon } from '../../atoms/Icons';
import QuizContent from '../../organisms/QuizContent';
import { StarIcon, ThumbsUpIcon, TimerIcon } from '../../atoms/Icons';
import {
	SurfaceColor,
	Grey500,
	ShadowColor,
} from '../../Colors';

export default {
	Wrapper: styled.div`
        background-color : ${SurfaceColor};
        cursor : pointer;
        white-space: pre-wrap;
        &:hover{
            box-shadow: 0 3px 6px ${ShadowColor};
        }
    `,
	Layout: styled.div`
        display : flex;
        position:relative;
        padding : 1rem;
    `,
	Divider: styled.div`
        margin : 0 1rem 0 1rem;
    `,

	UserBlock: styled.div`
    `,
	UserName: styled.div`
        color : ${Grey500};
        margin-top : 1rem;
        font-size : 0.5rem;
    `,
	IconGlyphicon: styled(UserIcon)`
        color : ${Grey500};
        font-size : 3rem;
    `,
	AvatarIcon: styled.img.attrs({
		width: '100px',
		height: '100px',
	})`
        cursor : pointer;
        border-radius : 1rem;
    `,
	RecipeBlock: styled.div`
        overflow-wrap : break-word;
        text-align : left;
        padding : 2rem 0 2rem 0;
    `,
	Title: styled.label`
        font-size : 1.5rem;
    `,
	Discription: styled.div`
        color : ${Grey500};
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align : left;
    `,
	TagsWrapper: styled.div`
        text-align : right;
        position : absolute;
        right : 5px;
        top : 5px;
    `,
	ReadOnlyTag: styled(ReadOnlyTag)`
        margin-right : 1rem;
    `,
	SupportingInfoWrapper: styled.div`
        text-align : right;
        min-height : 5px;
        position : relative;
    `,
	Icons: styled.div`
        position : absolute;
        right : 5px;
        bottom : 5px;
        font-size : 2rem;
        color : ${Grey500};
    `,
	QuizContent,
	StarIcon: styled(StarIcon)`
        margin-left : 1.5rem;
    `,
	ThumbsUpIcon: styled(ThumbsUpIcon)`
        margin-left : 1.5rem;    
    `,
	TimerIcon: styled(TimerIcon)`
        margin-left : 1.5rem; 
        margin-right : 1rem;   
    `,
	Timer: styled.span`
        font-size : 1.5rem;
    `,
};